@if (showLoading()) {
  <app-container-handling-rotterdam
      [berthVisitNumber]="berthVisitNumber()"
      [mode]="ContainerHandlingMode.LOADING"
      [showValidationErrors]="showValidationErrors()" />
}
@if (showDischarge()) {
  <app-container-handling-rotterdam
      class="d-block mt-4"
      [berthVisitNumber]="berthVisitNumber()"
      [mode]="ContainerHandlingMode.DISCHARGE"
      [showValidationErrors]="showValidationErrors()" />
}
